import React from "react";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import PromoTicker from "../components/landing/PromoTicker";
import Offers from "../components/landing/Offers";
import Categories from "../components/landing/Categories";
import StoreGallery from "../components/landing/StoreGallery";
import WhyChooseUs from "../components/landing/WhyChooseUs";
import LocationContact from "../components/landing/LocationContact";
import Footer from "../components/landing/Footer";
import WhatsAppFloat from "../components/landing/WhatsAppFloat";

export default function Landing() {
  return (
    <main
      className="min-h-screen bg-white text-[#1A1813] font-latin overflow-x-hidden"
      data-testid="landing-page"
    >
      <Navbar />
      <Hero />
      <PromoTicker />
      <Offers />
      <Categories />
      <StoreGallery />
      <WhyChooseUs />
      <LocationContact />
      <Footer />
      <WhatsAppFloat />
    </main>
  );
}
